import { render, staticRenderFns } from "./PreviousItemsSideCard.vue?vue&type=template&id=3898c34c&scoped=true&"
import script from "./PreviousItemsSideCard.vue?vue&type=script&lang=js&"
export * from "./PreviousItemsSideCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviousItemsSideCard.vue?vue&type=style&index=0&id=3898c34c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3898c34c",
  null
  
)

export default component.exports